<template>
  <div class="map-right-layers-item-feature map-right-layers-item-feature__container">
    <div class="map-right-layers-item-feature__check">
      <Checkbox
        v-model="isVisible"
        :binary="true"
        @click="toggleVisible"
      />
    </div>
    <div class="map-right-layers-item-feature__label">
      <span
        v-if="isEdittingRef"
        class="p-float-label map-right-layers-item-feature__label__input"
      >
        <InputText
          id="url"
          v-model="nameRef"
          type="text"
        />
        <label for="url">Nombre</label>
      </span>
      <span v-else>
        {{ nameRef }}
      </span>
    </div>
    <div class="map-right-layers-item-feature__buttons">
      <span
        v-tooltip.bottom="'Posicionar'"
        class="
          material-icons
          map-right-layers-item-feature__buttons__button
          map-right-layers-item-feature__buttons__button--green
        "
        @click="setPositionFeature"
      >
        place
      </span>
      <span
        v-tooltip.bottom="'Editar'"
        class="
          material-icons
          map-right-layers-item-feature__buttons__button
          map-right-layers-item-feature__buttons__button--blue
        "
        @click="toggleEdit"
      >
        {{ isEdittingRef ? 'done' : 'edit' }}
      </span>
      <span
        v-tooltip.bottom="'Eliminar'"
        class="
          material-icons
          map-right-layers-item-feature__buttons__button
          map-right-layers-item-feature__buttons__button--red
        "
        @click="() => emits('click-delete')"
      >
        delete_outline
      </span>
    </div>
  </div>
</template>


<script setup>
import {ref, inject} from 'vue';

// Openlayers
import {toLonLat} from 'ol/proj';

// Primevue
import Checkbox from 'primevue/checkbox';
import InputText from 'primevue/inputtext';

// config
import {STYLE_INVISIBLE, STYLE_DEFAULT} from '../../styles.config-styles';

// #region Props, Emits
const props___ = defineProps({
  feature: {
    type: Object,
    default: null,
  },
});
const emits = defineEmits(['click-delete', 'new-name']);
// #endregion


// #region Params, Ref, Reactives, Computed
const onChangeCenterProps = inject('onChangeCenterProps');
const isVisible = ref(props___.feature.getStyle() !== STYLE_INVISIBLE);
const nameRef = ref(props___.feature.getProperties().name ?? 'Nueva figura');
const isEdittingRef = ref(false);
// #endregion


// #region Functions
function setPositionFeature() {
  if (props___.feature.getGeometry().getType() === 'Point') {
    onChangeCenterProps(toLonLat(props___.feature.getGeometry().getCoordinates()));
  } else if (props___.feature.getGeometry().getType() === 'Polygon') {
    onChangeCenterProps(toLonLat(props___.feature.getGeometry().getCoordinates()[0][0]));
  } else if (props___.feature.getGeometry().getType() === 'MultiPolygon') {
    onChangeCenterProps(toLonLat(props___.feature.getGeometry().getCoordinates()[0][0][0]));
  }
}

function toggleVisible() {
  if (isVisible.value) {
    props___.feature.setStyle(STYLE_INVISIBLE);
  } else {
    props___.feature.setStyle(STYLE_DEFAULT);
  }
}

function toggleEdit() {
  isEdittingRef.value = !isEdittingRef.value;
  if (!isEdittingRef.value) {
    emits('new-name', nameRef.value);
  }
}
// #endregion


// #region Effects, Hooks
// ...
// #endregion


// #region Provide, Expose
// ...
// #endregion
</script>


<style lang="scss" scoped>
.map-right-layers-item-feature {
  &__container {
    display: flex;
    align-items: center;
    padding: 10px 0;
    max-height: 300px;
    overflow: auto;
  }

  &__label {
    flex: 1 1 100%;

    &__input {
      width: 100%;

      & > input {
        width: 100%;
      }
    }
  }

  &__check {
    flex: 0 0 auto;
    padding: 0px 5px;
  }

  &__buttons {
    flex: 0 0 auto;

    &__button {
      cursor: pointer;
      padding: 0 2px;

      &--green {
        color: $brand__color--green;
      }

      &--blue {
        color: $brand__color--blue;
      }

      &--red {
        color: $brand__color--red;
      }
    }
  }

}
</style>
